import React from "react";

import Layout from "../components/escuelasVacacionesLayout";

const Page = () => <Layout />;

export default Page;
